document.addEventListener('DOMContentLoaded', function () {
    const carrusel = document.querySelector('.subcategorias-carrusel');
    const nextBtn = document.querySelector('.carrusel-next');
    const prevBtn = document.querySelector('.carrusel-prev');

    if (!carrusel || !nextBtn || !prevBtn) {
      return;
    }

    const scrollAmount = carrusel.offsetWidth / 2;

    function updateButtons() {
      prevBtn.disabled = carrusel.scrollLeft === 0;
      nextBtn.disabled = Math.ceil(carrusel.scrollLeft + carrusel.offsetWidth) >= carrusel.scrollWidth;
    }

    nextBtn.addEventListener('click', () => {
      carrusel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      setTimeout(updateButtons, 300);
    });

    prevBtn.addEventListener('click', () => {
      carrusel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      setTimeout(updateButtons, 300);
    });

    updateButtons();
  });